import {
    REJECT_SET,
    REJECT_SET_SUCCESS,
    REJECT_SET_FAILURE,
    CLEAR_REJECT_SET,
} from '../actions';

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const rejectSetReducer = (state = initialState, action) => {
    switch (action.type) {
        case REJECT_SET:
            return {
                ...state,
                loading: true,
                data: null,
                error: null,
            };
        case REJECT_SET_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };
        case REJECT_SET_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case CLEAR_REJECT_SET:
            return initialState;
        default:
            return {
                ...state,
            };
    }
};

export default rejectSetReducer;